{
    "Accessibility menu": "ਪਹੁੰਚ ਮੇਨੂ",
    "Close": "ਬੰਦ ਕਰੋ",
    "Content adjustments": "ਸਮੱਗਰੀ ਸੰਸ਼ੋਧਨ",
    "Navigation adjustments": "ਨੇਵੀਗੇਸ਼ਨ ਸੰਸ਼ੋਧਨ",
    "Text Align": "ਟੈਕਸਟ ਇਕਸਾਰਤਾ",
    "Align Left": "ਖੱਬੇ ਪਾਸੇ ਇਕਸਾਰ ਕਰੋ",
    "Align Center": "ਕੇਂਦਰ ਵਿੱਚ ਇਕਸਾਰ ਕਰੋ",
    "Align Right": "ਸੱਜੇ ਇਕਸਾਰ ਕਰੋ",
    "Adjust Font Size": "ਫੋਂਟ ਆਕਾਰ ਅਨੁਕੂਲਿਤ ਕਰੋ",
    "Highlight Title": "ਸਿਰਲੇਖ ਹਾਈਲਾਈਟ ਕਰੋ",
    "Highlight Links": "ਲਿੰਕ ਹਾਈਲਾਈਟ ਕਰੋ",
    "Readable Font": "ਪੜ੍ਹਨਯੋਗ ਫੋਂਟ",
    "Colour adjustments": "ਰੰਗ ਸੰਸ਼ੋਧਨ",
    "Dark Contrast": "ਗੂੜ੍ਹਾ ਕੰਟ੍ਰਾਸਟ",
    "Light Contrast": "ਹਲਕਾ ਕੰਟ੍ਰਾਸਟ",
    "High Contrast": "ਉੱਚਾ ਕੰਟ੍ਰਾਸਟ",
    "High Saturation": "ਉੱਚੀ ਸੰਤ੍ਰਿਪਤੀ",
    "Low Saturation": "ਘੱਟ ਸੰਤ੍ਰਿਪਤੀ",
    "Monochrome": "ਇਕ ਰੰਗੀ",
    "Tools": "ਉਪਕਰਨ",
    "Reading Guide": "ਪੜ੍ਹਨ ਗਾਈਡ",
    "Big Cursor": "ਵੱਡਾ ਕਰਸਰ",
    "Increase Font Size": "ਫੋਂਟ ਆਕਾਰ ਵਧਾਓ",
    "Decrease Font Size": "ਫੋਂਟ ਆਕਾਰ ਘਟਾਓ",
    "Letter Spacing": "ਅੱਖਰਾਂ ਦੀ ਦੂਰੀ",
    "Line Height": "ਲਾਈਨ ਦੀ ਉਚਾਈ",
    "Font Weight": "ਫੋਂਟ ਭਾਰ",
    "Dyslexia Font": "ਡਿਸਲੈਕਸੀਆ ਫੋਂਟ",
    "Language": "ਭਾਸ਼ਾ",
    "Accessibility widget": "ਪਹੁੰਚ ਮੇਨੂ ਖੋਲ੍ਹੋ",
    "Accessibility Profiles": "ਪਹੁੰਚ ਪ੍ਰੋਫਾਈਲ",
    "Cognitive Disability": "ਬੋਧਾਤਮਕ ਅਸਮਰੱਥਾ",
    "Seizure Safe": "ਦੌਰਾ ਸੁਰੱਖਿਅਤ",
    "Accessibility statement": "ਪਹੁੰਚ ਬਿਆਨ",
    "ADHD": "ADHD",
    "Low Vision": "ਘੱਟ ਨਜ਼ਰ",
    "Pause Animations": "ਐਨੀਮੇਸ਼ਨ ਰੋਕੋ",
    "Animation paused": "ਐਨੀਮੇਸ਼ਨ ਰੋਕੀ ਗਈ",
    "Reset all settings": "ਸੈਟਿੰਗਾਂ ਰੀਸੈਟ ਕਰੋ",
    "Shortcut:": "ਸ਼ਾਰਟਕੱਟ:",
    "Epilepsy Safe Mode": "ਮਿਰਗੀ ਸੁਰੱਖਿਅਤ ਮੋਡ",
    "Mute sounds": "ਆਵਾਜ਼ਾਂ ਬੰਦ ਕਰੋ",
    "Page read": "ਪੰਨਾ ਪੜ੍ਹੋ",
    "Page read controls": "ਪੰਨਾ ਪੜ੍ਹਨ ਦੇ ਕੰਟਰੋਲ",
    "Pause": "ਰੋਕੋ",
    "Resume": "ਮੁੜ ਸ਼ੁਰੂ ਕਰੋ",
    "Stop": "ਬੰਦ ਕਰੋ",
    "Settings": "ਸੈਟਿੰਗਾਂ",
    "Speed": "ਗਤੀ",
    "Voice": "ਆਵਾਜ਼",
    "Close accessibility menu": "ਪਹੁੰਚਯੋਗਤਾ ਮੀਨੂ ਬੰਦ ਕਰੋ",
    "Back to accessibility menu": "ਪਹੁੰਚਯੋਗਤਾ ਮੀਨੂ 'ਤੇ ਵਾਪਸ ਜਾਓ",
    "Search languages": "ਭਾਸ਼ਾਵਾਂ ਖੋਜੋ",
    "Selected language": "ਚੁਣੀ ਗਈ ਭਾਸ਼ਾ",
    "View accessibility statement (opens in new window)": "ਪਹੁੰਚਯੋਗਤਾ ਬਿਆਨ ਵੇਖੋ (ਨਵੀਂ ਵਿੰਡੋ ਵਿੱਚ ਖੁੱਲ੍ਹਦਾ ਹੈ)",
    "Visit CookieYes website (opens in new window)": "CookieYes ਵੈੱਬਸਾਈਟ 'ਤੇ ਜਾਓ (ਨਵੀਂ ਵਿੰਡੋ ਵਿੱਚ ਖੁੱਲ੍ਹਦਾ ਹੈ)",
    "Reset all accessibility settings to default": "ਸਾਰੀਆਂ ਪਹੁੰਚਯੋਗਤਾ ਸੈਟਿੰਗਾਂ ਨੂੰ ਡਿਫੌਲਟ 'ਤੇ ਰੀਸੈਟ ਕਰੋ"
}
